module.exports = "<div class=\"iframe-div\" [innerHTML]=\"yt | safe: 'html'\"></div>\r\n"